import React, { Fragment, useEffect, useState } from 'react';
import { LogIn, Minimize } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import logoSalem from '../../assets/images/logo/logo-salem.png';
import user from "../../assets/images/user.png";


import { jwtDecode } from 'jwt-decode';

const Rightbar = () => {
  const token = document.cookie.split(`jwt=`).pop().split(';').shift();
  const loggedInUser = jwtDecode(token) ?? {};
  const navigate = useNavigate();
  const [moonlight, setMoonlight] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true)
    }
  }, []);

  const logoutAndClear = () => {
    document.cookie.split(";")
      .forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    navigate(`/login`)
  }

  function goFull() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const MoonlightToggle = (light) => {
    if (light) {
      setMoonlight(!light)
      document.body.className = "light"
      localStorage.setItem('layout_version', 'light');
    } else {
      setMoonlight(!light)
      document.body.className = "dark-only"
      localStorage.setItem('layout_version', 'dark-only');
    }
  }

  return (
    <Fragment>
      <header className=' nav-right header col-8 pull-right right-header  d-none d-print-block ' style={{paddingBottom:"0px",marginBottom:"0px"}}>
      <img className="img-fluid for-light " width={"250"} height={"70"} src={logoSalem} alt="" />
      </header>
      <div className="nav-right col-8 pull-right right-header p-0 d-print-none">
        <ul className="nav-menus">
          
          <li>
            <div className="mode" onClick={() => MoonlightToggle(moonlight)}><i className={`fa ${moonlight ? 'fa-lightbulb-o' : 'fa-moon-o'}`}></i></div>
          </li>
          
          <li className="maximize"><a className="text-dark" href="#javascript" onClick={goFull}><Minimize /></a></li>
          <li className="profile-nav onhover-dropdown p-0">
            <div className="media profile-media">
              <img className="b-r-10" src={user} alt="profile" />
              <div className="media-body">
                <span>{loggedInUser.lastname + " " + loggedInUser.firstname}</span>
                <p className="mb-0 font-roboto">{(loggedInUser.type === "admin" ? "Administrateur" : loggedInUser.type === "manager" ? "Chéf réseau" : loggedInUser.type === "supervisor" ? "Superviseur" : loggedInUser.type === "agent" ? "Délégué" : "")} <i className="middle fa fa-angle-down"></i></p>
              </div>
            </div>
            <ul className="profile-dropdown onhover-show-div">
             
              <li onClick={logoutAndClear}><LogIn /><span>Se déconnecter</span></li>
            </ul>
          </li>
        </ul>
      </div>
    </Fragment>

  );
}
export default Rightbar;